import type { Strapi5ResponseSingle } from '@nuxtjs/strapi';
import { apiClient } from '~/api';
import { textLinkPopulations } from '~/populations/base';
import { contentPopulations } from '~/populations/block-elements';
import type { Header } from '~/types/header';

export default async function getHeader(
  locale: string,
  type: 'default' | 'business',
) {
  const params = {
    locale,
    populate: {
      additionalLinks: true,
      mobileButtons: {
        populate: {
          image: true,
        },
      },
      desktopButtons: true,
      frequentRequests: {
        populate: {
          link: true,
        },
      },
      popularProducts: {
        populate: {
          title: true,
          description: true,
          tag: true,
          link: true,
          image: true,
          mobileImage: true,
        },
      },
      overlayContents: {
        populate: {
          linksColumns: {
            populate: {
              title: textLinkPopulations,
              links: true,
            },
          },
          card: {
            populate: {
              tag: true,
              heading: true,
              description: contentPopulations,
              button: true,
            },
          },
        },
      },
    },
  };

  const url = type && type === 'business' ? '/business-header' : '/header';

  const { data } = await apiClient<Strapi5ResponseSingle<Header>>(url, {
    cacheKey: getApiRequestCacheKey('header', {
      locale,
      type,
    }),
    params,
  });

  return data;
}
